import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, CloudSnow, Route, Smartphone, Receipt, Users, Settings, FileText, ChevronLeft, ChevronRight, Calendar, Building2 } from 'lucide-react';
interface SidebarProps {
  isOpen: boolean;
  onToggle: () => void;
}
const menuItems = [{
  icon: LayoutDashboard,
  label: 'Tableau de bord',
  path: '/'
}, {
  icon: Building2,
  label: 'Clients',
  path: '/clients'
}, {
  icon: Calendar,
  label: 'Planification',
  path: '/planning'
}, {
  icon: CloudSnow,
  label: 'Météo',
  path: '/weather'
}, {
  icon: Route,
  label: 'Optimisation',
  path: '/optimization'
}, {
  icon: Smartphone,
  label: 'Opérations',
  path: '/operations'
}, {
  icon: Receipt,
  label: 'Facturation',
  path: '/billing'
}, {
  icon: Users,
  label: 'Franchisés',
  path: '/franchises'
}, {
  icon: FileText,
  label: 'Rapports',
  path: '/reports'
}, {
  icon: Settings,
  label: 'Paramètres',
  path: '/settings'
}];
export function Sidebar({
  isOpen,
  onToggle
}: SidebarProps) {
  const navigate = useNavigate();
  const location = useLocation();
  return <aside className={`fixed left-0 top-0 h-full bg-white border-r border-gray-200 transition-all duration-300 z-20 ${isOpen ? 'w-64' : 'w-16'}`} data-id="element-610">
      {/* Logo */}
      <div className="h-16 flex items-center justify-between px-4 border-b border-gray-200" data-id="element-611">
        {isOpen && <div className="flex items-center space-x-2" data-id="element-612">
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-613">
              <span className="text-white font-bold" data-id="element-614">OP</span>
            </div>
            <span className="font-bold text-gray-900" data-id="element-615">OptiSnow</span>
          </div>}
        <button onClick={onToggle} className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-616">
          {isOpen ? <ChevronLeft className="w-5 h-5 text-gray-600" data-id="element-617" /> : <ChevronRight className="w-5 h-5 text-gray-600" data-id="element-618" />}
        </button>
      </div>
      {/* Menu Items */}
      <nav className="p-2 space-y-1" data-id="element-619">
        {menuItems.map((item, index) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        return <button key={index} onClick={() => navigate(item.path)} className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-colors ${isActive ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-620">
              <Icon className="w-5 h-5 flex-shrink-0" data-id="element-621" />
              {isOpen && <span className="text-sm font-medium" data-id="element-622">{item.label}</span>}
            </button>;
      })}
      </nav>
    </aside>;
}